import React from 'react';
import { toast } from 'react-hot-toast';
import { Link, useNavigate } from 'react-router-dom';
import userIcon from '../../assets/icon/icons8-user-48.png'
import { RiLoginBoxLine, RiUserFollowLine } from "react-icons/ri";
import { useQuery } from 'react-query';
import Loading from '../../pages/Loading/Loading';


const User = () => {
    const navigate = useNavigate()
    const token = localStorage.getItem('token');

    const { data, isLoading } = useQuery("mobileNotification", () => fetch(`${process.env.REACT_APP_SECRET_API}/user/notification`, {
        method: "GET",
        headers: {
            'content-type': "application/json",
            "X-Requested-With": "XMLHttpRequest",
            'authorization': `Bearer ${localStorage.getItem('token')}`
        }
    }).then((res) => res.json()), {
        staleTime: 1500, // set staleTime to 1 second
        refetchInterval: 3000 // fetch new data every 10 seconds
    });

    if (isLoading) {
        return <Loading></Loading>
    }

    const notification = data?.data;
 
    const unreadNotifications = notification ? notification.filter(item => item?.mark_as_read === 0) : [];
    const unreadNotificationCount = unreadNotifications.length;

    const logOut = () => {
        fetch(`${process.env.REACT_APP_SECRET_API}/logout`, {
            method: "POST",
            headers: {
                'X-Requested-With': 'XMLHttpRequest',

                authorization: `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => res.json())
            .then(data => {
                // console.log(data.data)
                if (data.success === true) {
                    toast.success("Logout Successfully")
                    localStorage.removeItem('token')
                    console.log(data)
                    navigate('/')
                    localStorage.removeItem('user_id')
                } else {
                    console.log(data)
                }
            })
        localStorage.removeItem('token')
    }
    return (
        <div>
            {token && token ? (
                <div className="dropdown dropdown-end sm:hidden lg:block">
                    <label tabIndex={0} className="flex lg:btn-circle lg:avatar  lg:text-white sm:text-black text-2xl">
                        <RiUserFollowLine className='lg:hidden' />

                        <div className="w-10 hidden lg:block rounded-full">
                            <img src={userIcon} className='logo' alt='something' />
                            {/* <span
                                className="absolute -top-1 lg:right-0 -right-2 w-5 h-5 rounded-full flex items-center justify-center bg-white text-black text-xs">
                                    5
                            </span> */}
                        </div>

                    </label>
                    <ul tabIndex={0} className="rounded p-2 shadow bg-blue-500 text-white menu menu-compact dropdown-content w-52 lg:top-14 -top-[138px]" style={{ right: "-40px" }}>
                        <li>
                            <Link to='/Profile' className="justify-between">
                                Profile
                                <span className="badge">New</span>
                            </Link>
                        </li>
                        <li className='relative'>
                            <Link to="/notification">
                                Message

                                {notification ? (
                                    <span
                                        className="absolute left-20 top-2 w-5 h-5 rounded-full flex items-center justify-center bg-white text-black text-xs">
                                        {unreadNotificationCount}
                                    </span>
                                ) :
                                    ""}

                            </Link>
                        </li>
                        <li><Link to="/order-history">Order History</Link></li>
                        <li><button onClick={logOut}>Logout</button></li>
                    </ul>
                </div>
            ) : (
                <Link to="/login" className='lg:text-white sm:text-black'><span className='hidden lg:block'>Login/Register</span><span className='block lg:hidden text-2xl'><RiLoginBoxLine /></span></Link>
            )}
        </div>
    );
};

export default User;